import { render, staticRenderFns } from "./ConfirmRate.vue?vue&type=template&id=20b097ed"
import script from "./ConfirmRate.vue?vue&type=script&lang=js"
export * from "./ConfirmRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports